import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable, of, tap } from 'rxjs';
import { Uf } from '../api/dto/uf';
import { CacheService } from './cache/cache.service';

@Injectable({
    providedIn: 'root'
})
export class UfService{

    private url: string = UrlServidor.URL_BASE + 'uf/';
    private cacheKey = 'ufs';
    private expiration = 10 * 60 * 1000;

    constructor(private http: HttpClient, private cacheService: CacheService<Uf[]>) { }
    
    listarUf(): Observable<Uf[]>  {
        const cachedUfs = this.cacheService.get(this.cacheKey);

        if (cachedUfs) {
            return of(cachedUfs);
        } else {
            return this.http.get<Uf[]>(this.url)
            .pipe(
                tap(ufs => this.cacheService.set(this.cacheKey, ufs, this.expiration))
              );
        }
        
    }  
    
}